import axios from 'axios';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.clients_api.client_reviews;


const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
}));

// Cached API wrapper for this namespace/group
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'clients_api',
  group: 'client_reviews',
  defaultTtl: '2m',
  hashLargeSegments: true,
  emitMeta: true,
});

// /GetAllClientReviewsByLocalId/<int:local_id>

export const getAllClientReviewsByLocalId = async (localId: number) => {
  return await retryWithBackoff(() =>
    cachedApi.get(`/GetAllClientReviewsByLocalId/${localId}`)
  );
}


export const createClientReview = async (clientId: number | null, receiptId: number, data: any) => {
  const res = await retryWithBackoff(() =>
    api.post('/CreateClientReview', {
      client_id: clientId,
      receipt_id: receiptId,
      data: data
    })
  );
  await cachedApi.clear();
  return res;
}